module.exports = __webpack_public_path__ + "img/1F1EC-1F1F8.b4b9ae01.svg";